import {makeAutoObservable} from "mobx";

export default class AudioPlayerStore {
    constructor() {
        this.audioRegionList = [];
        this.selectedAudioRegion = null;
        this.isOpen = false;
        this.isProcessing = false;
        this.dividePopoverState = false;
        this.popoverState = false;

        makeAutoObservable(this);
    }

    setIsOpen = (isOpen) => {
        this.isOpen = isOpen;
    }

    setIsProcessing = (isProcessing) => {
        this.isProcessing = isProcessing;
    }

    closeModal = () => {
        this.isOpen = false;

    }

    setAudioRegionList = (audioRegionList) => {
        this.audioRegionList = audioRegionList;
    }

    sortAudioRegionList = () => {
        this.audioRegionList = this.audioRegionList.sort((a,b) => a.start - b.start);
    }

    addAudioRegion = (region) => {
        this.audioRegionList.push(region);
    }

    removeAudioRegion = (region) => {
        const index = this.audioRegionList.findIndex(r => r === region)
        if (index !== -1) {
            this.audioRegionList.splice(index, 1);
        }
    }

    setSelectedAudioRegion = (region) => {
        if (this.selectedAudioRegion) {
            const rgba = this.selectedAudioRegion.color.split(',');
            rgba[3] = '0.2)';
            this.selectedAudioRegion.setOptions({color: rgba.join(',')})
        }

        if (region) {
            const rgba = region.color.split(',');
            rgba[3] = '0.7)';
            region.setOptions({color: rgba.join(',')})

            this.selectedAudioRegion = region;
        } else {
            this.selectedAudioRegion = null;
        }
    }

    setDividePopoverState = (boolean) => {
        if (this.dividePopoverState !== null) {
            this.dividePopoverState = boolean;
        }
    }

    setPopoverState = (boolean) => {
        if (this.popoverState !== null) {
            this.popoverState = boolean;
        }
    }
}
